import { render, staticRenderFns } from "./DeviceBatchCreate.vue?vue&type=template&id=706b9916&scoped=true&"
import script from "./DeviceBatchCreate.vue?vue&type=script&lang=js&"
export * from "./DeviceBatchCreate.vue?vue&type=script&lang=js&"
import style0 from "./DeviceBatchCreate.vue?vue&type=style&index=0&id=706b9916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b9916",
  null
  
)

export default component.exports